import {use} from 'react';

import {textFieldCtx} from '../utils/textFieldCtx';
import {TextFieldContext} from '../utils/types';

export const useTextFieldContext = (): TextFieldContext => {
  const ctx = use(textFieldCtx);

  return ctx;
};
